import "components/Flow/Flow.css";

import CommunityPathwayNode from "./CommunityPathwayNode";

export const nodeTypes = {
  communityPathwayNode: CommunityPathwayNode,
};